export const SVR_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const SVR_VIDEO_MAX_BYTES = 20 * 1024 * 1024;
export const SVR_TOTAL_MEDIA_MAX_BYTES = 250 * 1024 * 1024;

const IMAGE_MIME_TYPES = new Set(["image/jpeg", "image/png", "image/heic", "image/heif"]);
const VIDEO_MIME_TYPES = new Set(["video/mp4", "video/quicktime"]);

export type SvrMediaKind = "image" | "video";

export function normaliseSvrMediaMimeType(value: string | null | undefined): string {
  return String(value ?? "").split(";", 1)[0].trim().toLowerCase();
}

export function classifySvrMediaMimeType(value: string | null | undefined): SvrMediaKind | null {
  const mimeType = normaliseSvrMediaMimeType(value);
  if (IMAGE_MIME_TYPES.has(mimeType)) return "image";
  if (VIDEO_MIME_TYPES.has(mimeType)) return "video";
  return null;
}

export function maxBytesForSvrMediaKind(kind: SvrMediaKind): number {
  return kind === "video" ? SVR_VIDEO_MAX_BYTES : SVR_IMAGE_MAX_BYTES;
}

export function formatMediaBytes(bytes: number | null | undefined): string {
  const safeBytes = Number(bytes ?? 0);
  if (!Number.isFinite(safeBytes) || safeBytes <= 0) return "Size unavailable";
  if (safeBytes < 1024 * 1024) return `${Math.max(1, Math.round(safeBytes / 1024))} KB`;
  return `${(safeBytes / (1024 * 1024)).toFixed(1)} MB`;
}
